module.exports = __webpack_public_path__ + "static/media/6_r_odejda_88.75_46.48.fea90701.png";